const gridWrapper = document.querySelector(".screenshot-grid__grid-wrapper");

if (gridWrapper) {
  const imgWrappers = document.querySelectorAll(".screenshot-grid__img-wrapper");
  imgWrappers[0].classList.add("screenshot-grid__img-wrapper--first");

  switch (imgWrappers.length) {
    case 2:
      imgWrappers[1].classList.add("screenshot-grid__img-wrapper--large");
      break;
    case 3:
      imgWrappers[1].classList.add("screenshot-grid__img-wrapper--medium");
      imgWrappers[2].classList.add("screenshot-grid__img-wrapper--medium");
      break;
    case 4:
      imgWrappers[3].classList.add("screenshot-grid__img-wrapper--medium");
      break;
  }
}
